import { FormikValues, useFormik } from 'formik';
import {
  getAdminMap,
  mapDate,
} from '@pharmaplan/common';

import { parseMapDate } from '../../../helpers/Functions';
import { useAppDispatch } from '../../useAppDispatch';
import { useAppSelector } from '../../useAppSelector';

export const adminDashboardFilterInitialState = {
  daysInWeek: [],
  banners: [],
  startTime: null,
  endTime: null,
  startDate: null,
  endDate: null,
};

interface IUseAdminDashboardFilter {
  setFilterState: (
    value: React.SetStateAction<{
      submitted: boolean;
      showFilter: boolean;
    }>
  ) => void;
  filterState: {
    submitted: boolean;
    showFilter: boolean;
  };
}
const useAdminMapFilter = ({
  setFilterState,
  filterState,
}: IUseAdminDashboardFilter) => {
  const dispatch = useAppDispatch();

  const mDate = useAppSelector(mapDate);

  const handleSubmit = (values: FormikValues) => {
    const {
      softwareId,
    } = values ?? {};

    setFilterState({ ...filterState, submitted: true });
    dispatch(
      getAdminMap({
        ...parseMapDate(mDate),
        softwareId,
      }),
    );
  };

  const formik = useFormik({
    initialValues: {
      softwareId: '',
    },
    onSubmit: handleSubmit,
  });

  const resetFilter = () => {
    formik.resetForm();
    dispatch(
      getAdminMap(parseMapDate(mDate)),
    );
    setFilterState({ ...filterState, submitted: false });
  };

  return { formik, resetFilter };
};

export default useAdminMapFilter;
